<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GJy9ul/tc-custom/9781439675038.jpg?1738410291543" alt="This image is the cover for the book Ghostly Tales of the Adirondacks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghostly Tales of the Adirondacks
      </h1>
      <p class="bookDescription body article font2">
        <p>Ghost stories from the Adirondacks have never been so creepy, fun, and full of mystery!<br/><br/>The haunted history of The Mountains comes to life--even when the main players are dead. Visit the Sagamore Resort to catch a glimpse of the spirits who checked in but never checked out. Or look for ghosts amongst the stacks at the Woodgate Free Library. Dive into this spooky chapter book for suspenseful tales of bumps in the night, paranormal investigations, and the unexplained; just be sure to keep the light on.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Miller
      </h2>
      
      <p class="authorDescription body article">Karen has been writing about strange creatures since she was six, so writing about the paranormal is a perfect fit. She just moved to Iowa City and is excited to meet those ghosts.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28a58804